__turbopack_context__.v({
  "activityLine": "ai-chat-drawer-module__qeh59W__activityLine",
  "backLink": "ai-chat-drawer-module__qeh59W__backLink",
  "chatElement": "ai-chat-drawer-module__qeh59W__chatElement",
  "dockRow": "ai-chat-drawer-module__qeh59W__dockRow",
  "dockedPanel": "ai-chat-drawer-module__qeh59W__dockedPanel",
  "dockedPanelInner": "ai-chat-drawer-module__qeh59W__dockedPanelInner",
  "drawer": "ai-chat-drawer-module__qeh59W__drawer",
  "drawer-border-draw": "ai-chat-drawer-module__qeh59W__drawer-border-draw",
  "drawer-border-undraw": "ai-chat-drawer-module__qeh59W__drawer-border-undraw",
  "drawer-in": "ai-chat-drawer-module__qeh59W__drawer-in",
  "drawer-light-done": "ai-chat-drawer-module__qeh59W__drawer-light-done",
  "drawer-light-scan": "ai-chat-drawer-module__qeh59W__drawer-light-scan",
  "drawer-out": "ai-chat-drawer-module__qeh59W__drawer-out",
  "mcpActions": "ai-chat-drawer-module__qeh59W__mcpActions",
  "mcpConfirm": "ai-chat-drawer-module__qeh59W__mcpConfirm",
  "mcpDescription": "ai-chat-drawer-module__qeh59W__mcpDescription",
  "mcpDot": "ai-chat-drawer-module__qeh59W__mcpDot",
  "mcpFields": "ai-chat-drawer-module__qeh59W__mcpFields",
  "mcpFormActions": "ai-chat-drawer-module__qeh59W__mcpFormActions",
  "mcpHead": "ai-chat-drawer-module__qeh59W__mcpHead",
  "mcpHeading": "ai-chat-drawer-module__qeh59W__mcpHeading",
  "mcpIcon": "ai-chat-drawer-module__qeh59W__mcpIcon",
  "mcpIntro": "ai-chat-drawer-module__qeh59W__mcpIntro",
  "mcpItem": "ai-chat-drawer-module__qeh59W__mcpItem",
  "mcpList": "ai-chat-drawer-module__qeh59W__mcpList",
  "mcpMessage": "ai-chat-drawer-module__qeh59W__mcpMessage",
  "mcpMeta": "ai-chat-drawer-module__qeh59W__mcpMeta",
  "mcpName": "ai-chat-drawer-module__qeh59W__mcpName",
  "mcpNotice": "ai-chat-drawer-module__qeh59W__mcpNotice",
  "mcpPanel": "ai-chat-drawer-module__qeh59W__mcpPanel",
  "mcpStatus": "ai-chat-drawer-module__qeh59W__mcpStatus",
  "mcpText": "ai-chat-drawer-module__qeh59W__mcpText",
  "mcpTop": "ai-chat-drawer-module__qeh59W__mcpTop",
  "mcpUrl": "ai-chat-drawer-module__qeh59W__mcpUrl",
  "resizeHandle": "ai-chat-drawer-module__qeh59W__resizeHandle",
  "settingsIntro": "ai-chat-drawer-module__qeh59W__settingsIntro",
  "settingsRow": "ai-chat-drawer-module__qeh59W__settingsRow",
  "sidePanel": "ai-chat-drawer-module__qeh59W__sidePanel",
  "sidePanelClip": "ai-chat-drawer-module__qeh59W__sidePanelClip",
});
